import { defineComponent, h, onBeforeMount, onUnmounted } from 'vue'

import { _ } from '../../utils'
import { isPageEventType, useCurrentAppInstance } from '../composables'
import { PAGE_LOADED, PAGE_UNLOADED } from '../../consts'

export default defineComponent({
  props: {
    init: { type: [Object, Function] },
    meta: { type: Object }
  },

  setup(props, { slots }) {
    const app = useCurrentAppInstance()
    const { pagesStore } = app.stores

    const currentPageKey = app.currentRoute.value?.meta?.pageKey as string

    onBeforeMount(async () => {
      let data: any = {}

      const initProp = props.init || (props.meta?.init as any)

      try {
        // 初始化数据
        if (_.isFunction(initProp)) {
          data = await initProp(app, props.meta)
        } else if (initProp?.data) {
          if (_.isFunction(initProp?.data)) {
            data = await initProp?.data(app, props.meta)
          } else {
            data = initProp.data
          }
        } else if (initProp?.api) {
          data = await app.request(initProp.api)
        }
      } catch (err) {}

      // 加载时初始化页面数据
      await pagesStore.setCurrentPageData({ type: 'init', data })

      app.emits(PAGE_LOADED, initProp)
    })

    onUnmounted(async () => {
      /**
       * 卸载时清理页面数据
       * NOTICE： 数据在页面关闭窗口时已卸载，不需要再清理数据
       * 且在这里清理数据易导致清理错误页面（因为CurrentPage错位）
       */
      // await pagesStore.setCurrentPageData({ type: 'clear' })

      // 清除当前页面下所有注册事件（防止内存泄漏）
      if (currentPageKey) {
        app.emitter.all.keys().forEach((key: any) => {
          if (isPageEventType(key) && key.endsWith(`__${currentPageKey}`)) {
            app.emitter.off(key)
          }
        })
      }

      app.emits(PAGE_UNLOADED)
    })

    return () => {
      return h('div', slots.default?.())
    }
  }
})
